import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
}

const DeleteAlertModal = ({ onClose }: Props) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t('procurement.purchase_requests.settings.types.modals.delete_alert.title')}
      description={i18n.t(
        'procurement.purchase_requests.settings.types.modals.delete_alert.description'
      )}
      footer={
        <Button type="secondary" onClick={onClose}>
          {i18n.t('common.close')}
        </Button>
      }
      onClose={onClose}
    />
  )
}

export default DeleteAlertModal
